// extracted by mini-css-extract-plugin
export default {"root":"_2X-mn","content":"_2jvYf"};